<template>
	<header-block title="Documents" bgcolor="#FCE5D4dd"></header-block>
	<CustomerLoadWait :customer="customer && documents" :cardBlocks="true" />
	<transition>
		<div v-if="customer && documents">

			<div class="header">
				Uploaded Documents
				<p>{{ searchedDocuments.length }}</p>
				<div class="search">
					<v-row class="mb-4">
						<v-col class="search-col">
							<v-text-field
							ref="search"
							v-model="query"
							prepend-inner-icon="mdi-magnify"
							density="compact"
							label="Search"
							variant="solo"
							:flat="true"
							hide-details
							clearable
							single-line
							></v-text-field>
						</v-col>
					</v-row>
				</div>
			</div>

			<!-- Parent div to allow odd/even css selectors -->
			<div>
				<div :class="'hubItemWrapper'" v-for="a in searchedDocuments" :key="a.id">
					<AccountButton :circleIcon="true" :href="'#/documents/' + a.id" :title="a.documentName" :icon="a.sysoDocumentType && a.sysoDocumentType.icon ? require('@/assets/products/' + a.sysoDocumentType.icon + '.png') : require('@/assets/round1.png')" :provider="a.createDateTimeString" :balance="a.company ? a.company : a.documentSubject"></AccountButton>
				</div>
			</div>

			<div class="noDocuments" v-if="searchedDocuments.length == 0">
				<p>No documents found.  To upload documents, simply send them to us via WhatsApp.</p>
				<p>PDFs work best, but you can also take a clear photo of a document you have in paper form.</p>
				<p v-if="!customer.person.whatsAppEnabled">You do not currently have WhatsApp enabled. You will need to activate WhatsApp <a href="/#/enablewhatsapp">here</a>.</p>
			</div>

			<div style="clear:both; padding-bottom: 110px;"></div>

		</div>
	</transition>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import AccountButton from './elements/AccountButton.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import Helpers from '../mixins/Helpers';

export default {
	mixins: [Services, Helpers],
	components: { CustomerLoadWait, AccountButton, HeaderBlock },
	data() {
		return {
			section: 'd2d',
			drawerHeight: "82px",
			drawer:false,
			accounts: [],
			accountsBalance: 0,
			query: ''
		}
	},
	computed: {
		searchedDocuments() {
			var ret = [];
			if (this.query == "" || this.query == null) {
				ret = this.documents;
			} else {
				ret = this.documents.filter(v => {
					return JSON.stringify(v).toLowerCase().includes(this.query.toLowerCase());
				});
			}
			return ret;
		},
	},
	methods: {

		toggleTransactions: function() {
			this.drawer = !this.drawer;
			if (!this.drawer)
			{
				this.drawerHeight = "82px";
			}
			else
			{
				this.drawerHeight = "80%";
			}
		},

		getCustomer: function(){
			this._getCustomer(() => {
				this._getDocuments(() => {
				});
			});
		},

		onLoad: async function() {
			this.getCustomer();
		},

	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.header {
	background: linear-gradient(202deg, #FCE5D4 49.85%, #E0C5C8 100%);
	clear:both;
	margin-left: -30px;
	margin-right: -30px;
	margin-top: -20px;
	margin-bottom: 20px;
	color: var(--text-color);
	font-size: 15px;
	text-align: center;
	padding-top: 30px;
	padding-bottom: 5px;
	p{
		font-size: 48px;
		font-family: 'Gotham-Heavy';
		margin-top: 0px;
	};
	.search {
		padding-left: 30px;
		padding-right: 30px;
	}
}

.noDocuments {
	margin-top: 30px;
	font-size: 14px;
	text-align: center;
	p {
		text-align: center;
	}
}
</style>
